<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel active">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{'select_company' | translate}}</h2>
            </div>
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning height-38px" (click)="fnClosePanel()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div class="clear"></div>
        <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 margin-top-10 no-padding-right-left">
                <div class="block padding-top-0 ">
                    <div class="row margin-top-25">
                        <div class="col-lg-6 padding-left-0">
                            <div class="input-group">
                                <input type="text" class="form-control searchField" #searchField
                                    [ngClass]="{ 'has-value': searchField.value }" name="searchText"
                                    [(ngModel)]="searchText" autocomplete="off">
                                <label for="ExpenseCategory">{{ "label_search_criterion" | translate }}</label>
                                <span class="icons"><a>
                                        <i class="fas fa-search" aria-hidden="true"></i>
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block heightCalc-12 overflow-auto scrollbar-visible">
                    <div class="row">
                        <div class="col-lg-12 no-padding-right-left">

                            <div class="text-center noDataAvailable disabled opacity-60"
                                *ngIf="(companyList | grdFilter : {companyName: searchText}).length === 0">
                                {{ "no_data_available" | translate }}
                            </div>

                            <ul class="select-company">
                                <li class="border-bottom pb-3 mb-3 f-14 d-flex align-items-center justify-content-between gap-3 w-100pc"
                                    *ngFor="let item of companyList | grdFilter: { companyName: searchText}">
                                   
                                    <a class="company-name" (click)="fnSelectCompany(item)"
                                    [ngClass]="{ 'disabled': !item.isAccessAssigned, 'active': item.companyId == this.inputData?.companyId }">
                                   {{item.companyName}}
                                    </a>
                                  
                                    <a class="primary-tag px-2 py-1 mb-0" *ngIf="!item.isAccessAssigned && !item.status" (click)="fnShowSendRequestPanel(item)">
                                    {{ "why_this_is_disabled" | translate }}
                                    <i class="far fa-chevron-right ml-2"></i>
                                   </a>
                                  
                                   <a class="warning-tag px-2 py-1 mb-0" *ngIf="!item.isAccessAssigned && item.status === 1"
                                    (click)="fnShowSendRequestPanel(item)">
                                    {{ "request_status" | translate }}: {{ "card_access_request_pending_status" | translate }}
                                    <i class="far fa-chevron-right ml-2"></i>
                                  </a>
                                     
                                   <a class="danger-tag px-2 py-1 mb-0" *ngIf="!item.isAccessAssigned && item.status === 3"
                                    (click)="fnShowSendRequestPanel(item)">
                                   {{ "request_status" | translate }}: {{ "card_access_request_rejected_status" | translate }}
                                   <i class="far fa-chevron-right ml-2"></i>
                                  </a>

                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="rightSideBar" *ngIf="showSendRequestPanel">
    <div class="overLayDiv active"></div>
    <div class="rightSidePanel d-flex flex-column active">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2 *ngIf="!selectedItem.status">{{ "label_alert" | translate }}</h2>
                 <h2 *ngIf="selectedItem.status === 1">
                   {{ "request_status" | translate }}: {{ "card_access_request_pending_status" | translate }}
                 </h2>
                  <h2 *ngIf="selectedItem.status === 3">
                    {{ "request_status" | translate }}: {{ "card_access_request_rejected_status" | translate }}
                 </h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-primary mr-2" (click)="fnSendCompanyCardAccessGrantRequest()" 
                 [ngClass]="{'disabled': selectedItem.status === 1 || selectedItem.status === 3 }">
                    {{ "send_request" | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnCloseSendRequestPanel()">
                     {{ 'label_close' | translate}}
                </button>
            </div>
        </header>
        <div class="eod-panel-body-with-footer">
            <div class="block mt-2">
                <h6 class="info-text" *ngIf="!selectedItem.status"> 
                    <i class="fas fa-exclamation-circle eod-text-danger"></i>
                    <span> {{ 'comp_send_request_note1' | translate}}</span>
                </h6>

                <h6 class="info-text" *ngIf="selectedItem.status === 1">
                    <i class="fas fa-exclamation-circle eod-text-danger"></i>
                    <span>
                        {{'comp_send_request_note2_1' | translate}} <strong>{{selectedItem?.companyName}}</strong> {{'comp_send_request_note2_2' | translate}}
                        {{'comp_send_request_note2_3' | translate}} <strong>{{this.inputData?.financeManagerName}}</strong> 
                         <strong class="pl-1">({{this.inputData?.financeManagerEmail}})</strong>{{'comp_send_request_note2_5' | translate}}
                    </span>
                </h6>

                    <h6 class="info-text" *ngIf="selectedItem.status === 3">
                    <i class="fas fa-exclamation-circle eod-text-danger"></i>
                    <span>
                        {{'comp_send_request_note3_1' | translate}} <strong>{{selectedItem?.companyName}}</strong> {{'comp_send_request_note3_2' | translate}}
                        {{'comp_send_request_note3_3' | translate}} <strong>{{this.inputData?.financeManagerName}} </strong>
                         <strong>({{this.inputData?.financeManagerEmail}})</strong>{{'comp_send_request_note3_5' | translate}}
                    </span>
                </h6>

            </div>
        </div>
    </div>
</div>


<div id="rightSideBar" *ngIf="showJustificationPanel">
    <div class="overLayDiv active"></div>
    <div class="rightSidePanel d-flex flex-column active">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{'select_company' | translate}}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-primary mr-2" 
                [ngClass]="{'disabled': !(this.ccForm && this.ccForm.form && this.ccForm.form.dirty)}"
                (click)="fnSaveJustificationNotes()">
                     {{ "label_save" | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnCloseJustificationPanel()">
                     {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body-with-footer">
            <div class="block mt-2">
                <h6 class="info-text">
                    <i class="fas fa-exclamation-circle eod-text-danger"></i>
                    <span>
                        {{ 'add_com_justification_note1' | translate }} <strong>{{this.inputData?.cardCompanyName}}</strong>{{ 'add_com_justification_note2' | translate }} <strong>{{selectedItem?.companyName}}</strong>.
                        {{ 'add_com_justification_note3' | translate }}
                    </span>
                </h6>
            </div>

              <div class="mt-2">
                <dynamic-form [model]="ccFormModel" [fields]="ccFormFields"> </dynamic-form>
            </div>
        </div>
    </div>
</div>